"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var blockTypes = {
  PARAGRAPH: 'paragraph',
  HEADER: 'header',
  LIST: 'list',
  IMAGE: 'image',
  EMBED: 'embed',
  TWITTER: 'twitter',
  QUOTE: 'quote',
  SPOT_IM: 'spotim',
  TAGBOARD: 'tagboard',
  VIDEO: 'video'
};
var _default = blockTypes;
exports["default"] = _default;